export default __webpack_public_path__ + "static/media/dot_blue.2721e459.svg";